import {select} from "../../../../shared/SagaService";
import dayjs from 'dayjs';
import {NumberFormatHelper} from "../../../../components/NumberFormat/helpers";
import {Type} from "../../helper";
// import {PermissionCheck} from "../../../../components/Access/helper/permission/PermissionCheck";
import {Helper as InvoiceHelper} from "../../../../containers/AppPage/Sales/Invoices/helper";
import { getTransactionInitStatus } from '../../../../containers/AppPage/Shoebox/Form/common/getTransactionInitStatus';
import { DepositItemHelper } from 'bukku/components/Editable/PaymentDepositItem/helper';

export function* getInitData(transactionType) {
    const companyCurrencyCode = yield select(state => state.Auth.companyCurrencyCode);
    const { settings, terms, companyAddresses, paymentMethods } = yield select(state => state.List);

    // const draftOnly = PermissionCheck.withCurrentRoute().hasSomeModifier(['M3']);

    const date = dayjs().format("YYYY-MM-DD");
    const currency_code = companyCurrencyCode;
    const exchange_rate = 1;
    const tax_mode = settings.default_tax_mode || 'exclusive';
    // const status = draftOnly ? 'draft' : 'ready';
    const status = getTransactionInitStatus(transactionType);
    const number = NumberFormatHelper.getDefaultNumberFormat(transactionType);
    const description = settings[`description_${transactionType}`];

    const defaultPaymentMethod = paymentMethods.find(m => m.id === settings.default_payment_method_id);
    // const isDefaultPaymentMethodFeeNumeric = defaultPaymentMethod && !defaultPaymentMethod.fee_text?.includes('%');
    // has Percentage fee and it is not 0%
    // const isDefaultPaymentMethodFeePercentage = defaultPaymentMethod &&
    // defaultPaymentMethod.fee_text?.includes('%') &&
    // defaultPaymentMethod.fee_text !== '0%';

    const term_id = parseFloat(settings.default_term_id);

    const myinvois_action = 'NORMAL';

    // Quotation
    switch (transactionType) {
        case Type.sale_quote: {
            const term = terms.find(term => term.id === settings.default_term_id);
            return {
                date,
                currency_code,
                exchange_rate,
                number,
                tax_mode,
                status,
                term_id,
                description,
                due_date: InvoiceHelper.calcDueDateByTerm(term, date),
                term_items: [
                    {
                        term_id: parseFloat(settings.default_term_id) || undefined,
                        payment_due: '100%',
                        is_recurring: false,
                    },
                ],
                remarks: settings.sale_quote_remarks,
            };
        }
        case Type.sale_order: {
            const term = terms.find(term => term.id === settings.default_term_id);

            return {
                date,
                currency_code,
                exchange_rate,
                number,
                tax_mode,
                status,
                term_id,
                description,
                due_date: InvoiceHelper.calcDueDateByTerm(term, date),
                term_items: [
                    {
                        term_id: parseFloat(settings.default_term_id) || undefined,
                        payment_due: '100%',
                        is_recurring: false,
                    },
                ],
                remarks: settings.sale_order_remarks,
            };
        }
        case Type.sale_delivery_order:
            return {
                date,
                currency_code,
                exchange_rate,
                number,
                tax_mode,
                status,
                description,
                remarks: settings.sale_delivery_order_remarks,
            };
        case Type.sale_invoice:
            return {
                payment_mode: 'credit',
                date,
                currency_code,
                exchange_rate,
                number,
                tax_mode,
                status,
                description,
                remarks: settings.sale_invoice_remarks,
                rounding_on: settings.default_rounding_on, // change the Form.Item for rounding_on
                term_items: [
                    {
                        term_id: parseFloat(settings.default_term_id) || undefined,
                        payment_due: '100%',
                        is_recurring: false,
                    },
                ],
                myinvois_action,
            };
        case Type.sale_credit_note:
            return {
                date,
                currency_code,
                exchange_rate,
                number,
                tax_mode,
                status,
                description,
                remarks: settings.sale_credit_note_remarks,
                myinvois_action,
            };
        case Type.sale_payment: {
            // Fee Inclusive -  if the default payment method has non-null default fee amt (eg 0, 0%, 2, 2%),
            // the Fee Amount should be populated w default,
            // and thus the Fee Account should be selected with the default too.
            const {
                // showFee,
                feeAmount,
                defaultFeeAccount,
            } = DepositItemHelper.getDefaultFeeInfo(transactionType, defaultPaymentMethod, settings);

            const returnObj = {
                date,
                currency_code,
                exchange_rate,
                number,
                status,
                // payment_method_id: settings.default_payment_method_id,
                // account_id: settings.default_bank_cash_account_id,
                // account2_id: settings.default_transaction_fee_account_id,
                description,
                remarks: settings.official_receipt_remarks,
                deposit_items: [
                    {
                        payment_method_id: settings.default_payment_method_id,
                        account_id: defaultPaymentMethod?.account_id || settings.default_bank_cash_account_id,
                        amount: null,
                        fee_text: defaultPaymentMethod?.fee_text,
                        fee_amount: feeAmount,
                        fee_account_id: defaultFeeAccount,
                    },
                ],
            };

            return returnObj;
        }
        case Type.sale_refund: {
            // EXCLUSIVE FEE
            // const feeAmount = DepositItemHelper.getFeeAmount(defaultPaymentMethod?.fee_text, 'exclusive');
            // const hasFee = feeAmount || isDefaultPaymentMethodFeePercentage;
            // const defaultFeeAccount = defaultPaymentMethod?.fee_account_id ||
            //                         settings.default_transaction_fee_account_id;
            const {
                showFee,
                feeAmount,
                defaultFeeAccount,
            } = DepositItemHelper.getDefaultFeeInfo(transactionType, defaultPaymentMethod, settings);

            return {
                date,
                currency_code,
                exchange_rate,
                number,
                status,
                // payment_method_id: settings.default_payment_method_id,
                // account_id: settings.default_bank_cash_account_id,
                // account2_id: settings.default_transaction_fee_account_id,
                description,
                remarks: settings.payment_voucher_remarks,
                deposit_items: [
                    {
                        payment_method_id: settings.default_payment_method_id,
                        account_id: defaultPaymentMethod?.account_id || settings.default_bank_cash_account_id,
                        amount: null,
                        fee_text: showFee ? defaultPaymentMethod?.fee_text : null,
                        fee_amount: showFee ? feeAmount : null,
                        fee_account_id: showFee ? defaultFeeAccount : null,
                    },
                ],
            };
        }
        case Type.purchase_order: {
            const addressInfo = companyAddresses.find(a => a.is_default_shipping);
            const term = terms.find(term => term.id === settings.default_term_id);

            return {
                date,
                currency_code,
                exchange_rate,
                number,
                tax_mode,
                status,
                term_id,
                remarks: settings.purchase_order_remarks,
                show_shipping: !!addressInfo,
                shipping_party: addressInfo?.address || null,
                due_date: InvoiceHelper.calcDueDateByTerm(term, date),
                term_items: [
                    {
                        term_id: parseFloat(settings.default_term_id) || undefined,
                        payment_due: '100%',
                        is_recurring: false,
                    },
                ],
                description,
            };
        }
        case Type.purchase_goods_received_note: {
            const addressInfo = companyAddresses.find(a => a.is_default_shipping);
            return {
                date,
                currency_code,
                exchange_rate,
                number,
                tax_mode,
                status,
                remarks: settings.purchase_goods_received_note_remarks,
                show_shipping: !!addressInfo,
                shipping_party: addressInfo?.address || null,
                description,
            };
        }
        case Type.purchase_bill: {
            const term = terms.find(term => term.id === settings.default_term_id);
            const addressInfo = companyAddresses.find(a => a.is_default_shipping);

            return {
                date,
                currency_code,
                exchange_rate,
                number,
                tax_mode,
                status,
                payment_mode: 'credit',
                // term_id,
                due_date: InvoiceHelper.calcDueDateByTerm(term, date),
                payment_method_id: settings.default_payment_method_id,
                account_id: settings.default_bank_cash_account_id,
                term_items: [
                    {
                        term_id: parseFloat(settings.default_term_id) || undefined,
                        payment_due: '100%',
                        is_recurring: false,
                    },
                ],
                description,
                myinvois_action,
                show_shipping: !!addressInfo,
                shipping_party: addressInfo?.address || null,
            };
        }
        case Type.purchase_credit_note: {
            const addressInfo = companyAddresses.find(a => a.is_default_shipping);

            return {
                date,
                currency_code,
                exchange_rate,
                number,
                tax_mode,
                status,
                description,
                remarks: settings.sale_credit_note_remarks,
                myinvois_action,
                show_shipping: !!addressInfo,
                shipping_party: addressInfo?.address || null,
            };
        }
        case Type.purchase_payment: {
            // EXCLUSIVE FEE
            // const feeAmount = DepositItemHelper.getFeeAmount(defaultPaymentMethod?.fee_text, 'exclusive');
            // const hasFee = feeAmount || isDefaultPaymentMethodFeePercentage;
            // const defaultFeeAccount = defaultPaymentMethod?.fee_account_id ||
            //                         settings.default_transaction_fee_account_id;

            const {
                showFee,
                feeAmount,
                defaultFeeAccount,
            } = DepositItemHelper.getDefaultFeeInfo(transactionType, defaultPaymentMethod, settings);

            return {
                date,
                currency_code,
                exchange_rate,
                number,
                status,
                // payment_method_id: settings.default_payment_method_id,
                // account_id: settings.default_bank_cash_account_id,
                // account2_id: settings.default_transaction_fee_account_id,
                description,
                remarks: settings.payment_voucher_remarks,
                deposit_items: [
                    {
                        payment_method_id: settings.default_payment_method_id,
                        account_id: defaultPaymentMethod?.account_id || settings.default_bank_cash_account_id,
                        amount: null,
                        fee_text: showFee ? defaultPaymentMethod?.fee_text : null,
                        fee_amount: showFee ? feeAmount : null,
                        fee_account_id: showFee ? defaultFeeAccount : null,
                    },
                ],
            };
        }
        case Type.purchase_refund: {
            // Fee Inclusive -  if the default payment method has non-null default fee amt (eg 0, 0%, 2, 2%),
            const feeText = defaultPaymentMethod?.fee_text;
            const feeAmount = DepositItemHelper.getFeeAmount(feeText, 'inclusive');
            // the Fee Amount should be populated w default,
            // and thus the Fee Account should be selected with the default too.
            const defaultFeeAccount = feeText !== null ?
                defaultPaymentMethod?.fee_account_id :
                settings.default_transaction_fee_account_id;

            return {
                date,
                currency_code,
                exchange_rate,
                number,
                status,
                // payment_method_id: settings.default_payment_method_id,
                // account_id: settings.default_bank_cash_account_id,
                // account2_id: settings.default_transaction_fee_account_id,
                description,
                remarks: settings.official_receipt_remarks,
                deposit_items: [
                    {
                        payment_method_id: settings.default_payment_method_id,
                        account_id: defaultPaymentMethod?.account_id || settings.default_bank_cash_account_id,
                        amount: null,
                        fee_text: defaultPaymentMethod?.fee_text,
                        fee_amount: feeAmount,
                        fee_account_id: feeAmount ? defaultFeeAccount : null,
                    },
                ],
            };
        }
        case Type.bank_income: {
            // Fee Inclusive -  if the default payment method has non-null default fee amt (eg 0, 0%, 2, 2%),
            // the Fee Amount should be populated w default,
            // const feeText = defaultPaymentMethod?.fee_text;
            // const feeAmount = DepositItemHelper.getFeeAmount(feeText, 'inclusive');
            // // and thus the Fee Account should be selected with the default too.
            // const defaultFeeAccount = feeText !== null ?
            //     defaultPaymentMethod?.fee_account_id :
            //     settings.default_transaction_fee_account_id;

            const {
                showFee,
                feeAmount,
                defaultFeeAccount,
            } = DepositItemHelper.getDefaultFeeInfo(transactionType, defaultPaymentMethod, settings);

            return {
                date,
                currency_code,
                exchange_rate,
                number,
                tax_mode,
                status,
                // account_id: settings.default_bank_cash_account_id,
                // account2_id: settings.default_transaction_fee_account_id,
                // payment_method_id: settings.default_payment_method_id,
                rounding_on: false, // change the Form.Item for rounding_on
                description,
                remarks: settings.official_receipt_remarks,
                deposit_items: [
                    {
                        payment_method_id: settings.default_payment_method_id,
                        account_id: defaultPaymentMethod?.account_id || settings.default_bank_cash_account_id,
                        amount: null,
                        fee_text: defaultPaymentMethod?.fee_text,
                        fee_amount: showFee ? feeAmount : null,
                        fee_account_id: showFee ? defaultFeeAccount : null,
                    },
                ],
            };
        }
        case Type.bank_expense: {
            // EXCLUSIVE FEE
            // const feeAmount = DepositItemHelper.getFeeAmount(defaultPaymentMethod?.fee_text, 'exclusive');
            // const hasFee = feeAmount || isDefaultPaymentMethodFeePercentage;
            // const defaultFeeAccount = defaultPaymentMethod?.fee_account_id ||
            //                         settings.default_transaction_fee_account_id;

            const {
                showFee,
                feeAmount,
                defaultFeeAccount,
            } = DepositItemHelper.getDefaultFeeInfo(transactionType, defaultPaymentMethod, settings);

            return {
                date,
                currency_code,
                exchange_rate,
                number,
                status,
                tax_mode: settings.default_tax_mode || 'inclusive',
                // account_id: settings.default_bank_cash_account_id,
                // account2_id: settings.default_transaction_fee_account_id,
                // payment_method_id: settings.default_payment_method_id,
                rounding_on: false, // change the Form.Item for rounding_on
                description,
                remarks: settings.payment_voucher_remarks,
                deposit_items: [
                    {
                        payment_method_id: settings.default_payment_method_id,
                        account_id: defaultPaymentMethod?.account_id || settings.default_bank_cash_account_id,
                        amount: null,
                        fee_text: showFee ? defaultPaymentMethod?.fee_text : null,
                        fee_amount: showFee ? feeAmount : null,
                        fee_account_id: showFee ? defaultFeeAccount : null,
                    },
                ],
            };
        }
        case Type.bank_transfer:
            return {
                date,
                currency_code,
                exchange_rate,
                number,
                status,
                account_id: settings.default_bank_cash_account_id,
                account2_id: settings.default_bank_cash_account_id,
                description,
            };
        case Type.stock_adjustment:
            return {
                date,
                number,
                status,
                account_id: settings.default_inventory_adjustment_account_id || null,
                description,
            };
        case Type.stock_transfer:
            return {
                date,
                number,
                status,
                description,
            };
        case Type.contra:
            return {
                date,
                currency_code,
                exchange_rate,
                number,
                status,
                description,
                remarks: settings.contra_remarks,
            };

        case Type.journal_entry:
            return {
                date,
                currency_code,
                exchange_rate,
                number,
                status,
                description,
                remarks: settings.journal_entry_remarks,
            };

        case Type.tax_deemed_payment:
            return {
                date: (
                    dayjs()
                        .subtract(1, 'month')
                        .endOf('month')
                        .format("YYYY-MM-DD")
                ),
                currency_code,
                exchange_rate,
                number,
                status,
                description,
            };

        default:
            return {};
    }
}
